<template>
    <div class="Achieving">
        <div class="Achieving-dv">
            <div class="Achieving-dvh">
                <!-- <img src="../../assets/bg-chengzhang01.png" alt=""> -->
                <h1>课程达成记录</h1>
            </div>
        </div>
        <div class="Achieving-dv1">
            <ul>
                <li v-for="(item,index) in list" :key="index" >
                    <div class="biaoti">

                    </div>
                    <span>{{item.title}}</span>
                    <div class="arrowshang" v-if="item.showifon" @click.stop="openshang(item,index)">

                    </div>
                    <div class="arrowxia" v-else @click.stop="open(item,index)">

                    </div>
                    <transition name="hehe">
                        <div class="Achieving_content" v-if="item.showifon">
                            <div class="fan_dv">
                                <div class="fan_dv1" v-for="(it,d) in item.courseList" :key="d" @click="jumpAchievement(it.id,it.name)">
                                    {{it.name}}
                                </div>
                            </div>
                        </div>
                    </transition> 
                </li>
            </ul>
        </div>
        <back-to :path="'/'"></back-to>
    </div>
</template>
<script>
import backTo from '@/components/back'
import api from "@/api"
export default {
    components: { backTo },
    data(){
        return{
            chart: null,
            isActive:0,
            pointList:[], //柱状图数据
            list:[],
        }
    },
    methods:{
        open(item,index){
            const self=this
            self.$set(self.list[index], 'showifon', true)
            if(item.courseList == undefined ){
                this.$toast({
                    message: '暂时没有数据',
                    position: 'bottom'
                })
            }
        },
        openshang(item,index){
            const self=this
            self.$set(self.list[index], 'showifon', false)
        },
        // 成绩分析
        jumpAchievement(ids,name){
            this.$router.push({path: '/AchievementAnalysis',query:{courseId:ids,name:name}})
        },
        //  列表查询
        getAllCourseByVersionId(){
            let classId = JSON.parse(localStorage.getItem('userInfo')).classId
            this.$get(api.questionnaire.gradeAndCourse(classId)).then(res=>{
                if(res.status == 1){
                    res.data.forEach(element => {
                        element.showifon = false
                    });
                    console.log()
                    this.list =res.data
                    console.log(this.list,'this.list')
                }
            })
        }
    },
    mounted () {
        this.getAllCourseByVersionId()
    },
}
</script>
<style lang="scss" scoped>
    .Achieving{
        height: 100%;
        .Achieving-dv{
            .Achieving-dvh{
                width: 100%;
                height: 318px;
                background: url('../../assets/bg-chengzhang01.png') no-repeat center center;
                background-size: 100% 100%;
                h1{
                    position: absolute;
                    right:  -60px; 
                    top: 160px; 
                    transform: translate(-50%, -50%);
                    font-size:40px;
                    font-family:PingFangSC;
                    font-weight:600;
                    color:rgba(255,255,255,1);
                    // letter-spacing: 5px;
                    display: block;
                }
                img{
                    width: 100%;
                    height: 318px;
                }
            }
        }
        .Achieving-dv1{
            width: 100%;
            position: absolute;
            top: 270px;
            padding: 0 24px;
            .hehe-enter,.hehe-leave-to{
                opacity: 0;
            }
            .hehe-enter-to,.hehe-start{
                opacity: 0.5;
            }
            .hehe-enter-start,.hehe-leave{
                opacity: 1;
            }
            .hehe-enter-active,.hehe-leave-active{
                transition: ease-in 0.2s;
            }
            ul{
                li{
                    list-style: none;
                    background:rgba(255,255,255,1);
                    box-shadow:$box-shadow;
                    border-radius:10px;
                    padding: 40px 30px;
                    margin-bottom: 30px;
                    img{
                        width: 40px;
                        height: 22px;
                        margin-right: 10px;
                    }
                    img:nth-child(3){
                        width:30px;
                        height:30px;
                        float:right;
                        margin-top: 10px;
                    }
                    .arrowshang{
                        float:right;
                        width:30px;
                        height:30px;
                        background: url('../../assets/arrow-shang.png') no-repeat center center;
                        background-size: 100% 100%; 
                        margin-top: 10px;
                    }
                    .arrowxia{
                        margin-top: 10px;
                        float:right;
                        width:30px;
                        height:30px;
                        background: url('../../assets/arrow-xia.png') no-repeat center center;
                        background-size: 100% 100%; 
                    }
                    .biaoti{
                        margin-top: 10px;
                        float:left;
                        width:45px;
                        height:25px;
                        margin-right: 15px;
                        background: url('../../assets/dian-biaoti.png') no-repeat center center;
                        background-size: 100% 100%; 
                    }
                    span{
                        font-size:30px;
                        font-family:PingFangSC;
                        font-weight:700;
                        color:rgba(50,50,50,1);
                    }
                    .Achieving_content{
                        .fan_dv{
                            margin-top: 35px;
                            padding-left: 6px;
                            .fan_dv1{
                                padding: 16px 38px;
                                background:rgba(244,244,244,1);
                                border-radius:10px;
                                display: inline-block;
                                margin-right: 20px;
                                font-size:24px;
                                font-family:PingFangSC;
                                font-weight:400;
                                color:rgba(150,150,150,1);
                                margin-bottom: 20px;
                                width: 100%;
                            }
                        }
                    }
                }
            }
        }
    }
   
</style>